import Const from 'constants';
import {getTeamNamesOfGames} from 'helpers/game-helper';
import AlertableError from 'errors/alertable-error';
import GameModel from 'models/game';

let Game = {
    applyGames(games) {
        return (dispatch) => {
            const gameModels = (games || []).map((game) => GameModel.fromGamePayload(game));

            dispatch(this.setGames(gameModels));
            dispatch(this.loadFiltersFromStorage('selectedGames'));
            dispatch(this.setGamesFilterIfNecessary(gameModels));
        };
    },
    applyUpdatedGames(updatedGames) {
        return (dispatch, getState) => {
            const {
                playersData: {games: prevGames},
            } = getState();

            const gameModels = (updatedGames || []).map((game) => GameModel.fromGamePayload(game));

            dispatch(this.setGames(gameModels));
            dispatch(this.setGamesFilterIfNecessary(gameModels));

            const indexedGames = prevGames.getAllIndexedByGameInfo();
            const gamesWithChangedStatuses = gameModels.filter(
                (game) => game.gameInfo in indexedGames && game.isActive !== indexedGames[game.gameInfo].isActive,
            );

            dispatch(this.updatePlayersWhoseGameStatusChanged(gamesWithChangedStatuses));
        };
    },
    addGamesIfAbsent(games) {
        return (dispatch, getState) => {
            const {
                playersData: {games: existingGames},
            } = getState();

            const indexedGames = existingGames.getAllIndexedByGameInfo();

            const absentGames = games
                .filter((game) => !(game.gameInfo in indexedGames))
                .map((game) => GameModel.fromGamePayload(game));

            if (isEmpty(absentGames)) {
                return;
            }

            const existingTeamNames = getTeamNamesOfGames(existingGames.getAllAsArr());
            const absentTeamNames = getTeamNamesOfGames(absentGames);
            const duplicates = arrayDuplicates(existingTeamNames, absentTeamNames);

            if (!isEmpty(duplicates)) {
                throw new AlertableError(
                    `Teams ${duplicates.join(', ')} were found in different games. Perhaps chosen slate does not match to the uploaded file with lineups.`,
                );
            }

            dispatch(this.setGames([...existingGames.getAllAsArr(), ...absentGames]));

            dispatch(this.setGamesFilter([...existingTeamNames, ...absentTeamNames]));
        };
    },
    setGames(gameModels) {
        return (dispatch, getState) => {
            const {sportConfig} = getState();

            sportConfig.isModeLateswap() && gameModels.map((game) => game.lockIfStarted());

            return dispatch({
                type: Const.GET_GAMES_SUCCESS,
                data: gameModels,
            });
        };
    },
    refreshGamesStatuses() {
        return (dispatch, getState) => {};
    },
};

export default Game;
